import CustomSpinner from 'utils/Spinner/Spinner';
import {toCurrency} from 'utils/helpers';
import {DetailRow} from './LASGInvoiceCard';

const LASGChargesBreakdown = ({chargesData, isLoading}) => {
    if (!isLoading && !chargesData) return null;

    return (
        <div className="bg-light border rounded-3 p-3 mb-4">
            <p className="text-uppercase fw-bold text--gray mb-3" style={{letterSpacing: '0.6px'}}>
                Charges Breakdown
            </p>
            {isLoading ? (
                <div className="d-flex justify-content-center py-5">
                    <CustomSpinner cls="text-secondary spinner-border-lg" />
                </div>
            ) : (
                <ul className="list-group list-group-flush">
                    <DetailRow label="Amount" value={`₦${toCurrency(chargesData.amount)}`} />
                    <DetailRow label="Fee" value={`₦${toCurrency(chargesData.charges)}`} />
                    <DetailRow
                        label="Total"
                        value={`₦${toCurrency(
                            chargesData.amountCustomerPays ?? chargesData.amount
                        )}`}
                        valueClassName="fw-bold"
                    />
                </ul>
            )}
        </div>
    );
};

export default LASGChargesBreakdown;
